import Layout from "../components/layout/Layout";
import SEO, { orgSchema, websiteSchema, faqSchema } from "../components/layout/SEO";
import Hero from "../components/home/Hero";
import CaseReviewSection from "../components/home/CaseReviewSection";
import ProcedureCategories from "../components/home/ProcedureCategories";
import Manifesto from "../components/home/Manifesto";
import HowWeHelp from "../components/home/HowWeHelp";
import TrustSafety from "../components/home/TrustSafety";
import WhyVietnam from "../components/home/WhyVietnam";
import PatientJourney from "../components/home/PatientJourney";
import GuidePreviews from "../components/home/GuidePreviews";
import Revision from "../components/home/Revision";
import Support from "../components/home/Support";
import Results from "../components/home/Results";
import { DoctorReviewPreview, AftercarePreview } from "../components/home/HomePreviews";
import FAQ from "../components/home/FAQ";
import FinalCTA from "../components/home/FinalCTA";
import EditorialMarquee from "../components/shared/Marquee";
import { FAQS } from "../data/faqs";
import { useI18n } from "../i18n";

export default function Home() {
  const { t } = useI18n();
  return (
    <Layout>
      <SEO
        title={t("meta.home_title")}
        description={t("meta.home_description")}
        path="/"
        schema={[orgSchema(), websiteSchema(), faqSchema(FAQS)]}
      />
      <Hero />
      <EditorialMarquee items={t("marquee")} />
      <CaseReviewSection />
      <ProcedureCategories />
      <Manifesto />
      <HowWeHelp />
      <TrustSafety />
      <DoctorReviewPreview />
      <WhyVietnam />
      <PatientJourney />
      <GuidePreviews />
      <Revision />
      <Support />
      <AftercarePreview />
      <Results />
      <FAQ />
      <FinalCTA />
    </Layout>
  );
}
